// extracted by mini-css-extract-plugin
export default {"row":"_7ec0737aac90b4e4"};